var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClassroomBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1003,
    height: 48,
    viewBox: "0 2 1003 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1692_27998)",
    filter: "url(#filter0_d_1692_27998)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1069.87,
    height: 86,
    transform: "translate(0 2)",
    fill: "url(#paint0_linear_1692_27998)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1692_27998)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 900.128,
    height: 134,
    transform: "translate(59.1514 3)",
    fill: "white",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_1692_27998)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 568.367,
    height: 165,
    transform: "translate(0 28)",
    fill: "white",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_1692_27998)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 493.785,
    height: 141,
    transform: "translate(676.382 15)",
    fill: "white",
    fillOpacity: 0.05
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1692_27998",
    x: -4,
    y: 0,
    width: 1011,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1692_27998"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1692_27998",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1692_27998",
    x: 55.1514,
    y: -1,
    width: 908.128,
    height: 142,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1692_27998"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1692_27998",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_1692_27998",
    x: -4,
    y: 24,
    width: 576.367,
    height: 173,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1692_27998"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1692_27998",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_1692_27998",
    x: 672.382,
    y: 11,
    width: 501.785,
    height: 149,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1692_27998"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1692_27998",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1692_27998",
    x1: 180.315,
    y1: 5.79775,
    x2: 187.318,
    y2: 122.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#029690"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DD821"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1692_27998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1003,
    height: 48,
    fill: "white",
    transform: "translate(0 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassroomBg);
export default __webpack_public_path__ + "static/media/classroomBg.5b63902ba0b3552d52b044ba6c27046e.svg";
export { ForwardRef as ReactComponent };